<template>
  <div v-if="!isLoading">
    <SearchTagEmptyMessage
      v-if="!hasCount & !isDataLoading"
      :page-type="pageType"
      :category="category"
    />

    <template v-else>
      <SearchResultListTitle
        :total-count="totalCount"
        :category="`${category}${mtype}`"
        :filter="filter"
      />

      <SearchTagResultList
        :cell-list="cellList"
        :thumbnail-info="thumbnailInfo"
        @load-more-fn="loadMore"
      />
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import { postSearchTagList } from '@/common/utils/request'
import { getThumbnailInfo } from '@/common/utils/common'
import SearchResultListTitle from '@/components/search/view/SearchResultListTitle'
import SearchTagResultList from '@/components/search/view/SearchTagResultList'
import SearchTagEmptyMessage from '@/components/search/view/SearchTagEmptyMessage'

export default {
  name: 'SearchTagList',
  components: {
    SearchResultListTitle,
    SearchTagResultList,
    SearchTagEmptyMessage
  },
  props: {
    tagDataList: {
      type: Array,
      default: null
    },
    pageType: {
      type: String,
      default: 'broadcast' // 'broadcast' | 'movie'
    },
    category: {
      type: String,
      default: '' // 'all' | 'vod' | 'movie'
    }
  },
  data () {
    return {
      thumbnailInfo: {}, // object []
      cellType: '', // string
      isLoading: true, // 초기 모든 데이터 로딩 여부 | boolean
      isDataLoading: true, // 비동기 데이터 로딩 여부 | boolean
      totalCount: 0, // number
      limit: 20, // number
      cellList: [], // object []
      endOfList: false, // offset end 여부 | boolean
      offset: 0, // number
      filter: {}, // object []
      mtype: '', // 'ppv' | 'svod'
      transactionkey: (this.$route?.query?.transactionkey || ''), // string
      orderby: (this.$route?.query?.orderby || 'score') // string
    }
  },
  computed: {
    hasCount () {
      return this.cellList.length > 0
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    addMovieMediaType () {
      this.mtype = this.$route?.query?.mtype || ''
      return { mtype: this.mtype }
    },
    setListData (data) {
      const appendCellList = _.get(data, 'cell_toplist.celllist', [])
      const totalCount = _.get(data, 'cell_toplist.totalcount', '0')
      const cellType = _.get(data, 'cell_toplist.cell_type', this.cellType)

      this.cellType = cellType
      this.filter = _.get(data, 'filter', {})
      this.totalCount = Math.max(Number(totalCount), this.totalCount)
      this.cellList = [...this.cellList, ...appendCellList]
      this.thumbnailInfo = getThumbnailInfo(cellType)
      this.endOfList = _.get(data, 'cell_toplist.celllist', this.cellList).length === 0
    },
    drawParameters () {
      const isPageTypeMovie = (this.pageType === 'movie')
      const defaultParams = {
        limit: this.limit,
        offset: this.offset,
        searchtags: this.tagDataList,
        type: this.category,
        orderby: this.orderby,
        transactionkey: this.transactionkey,
        version: 2
      }
      if (isPageTypeMovie) Object.assign(defaultParams, this.addMovieMediaType())

      return defaultParams
    },
    async fetchData () {
      this.isDataLoading = true
      try {
        const params = this.drawParameters()
        const { data } = await postSearchTagList(_.assign(params))
        this.setListData(data)
      } catch (error) {
        console.error(error)
      } finally {
        this.isDataLoading = false
        this.isLoading = false
      }
    },
    loadMore () {
      if (this.endOfList) return
      this.offset += this.limit
      this.fetchData()
    },
    resetData () {
      this.cellList = []
      this.offset = 0
      this.totalCount = 0
      this.filter = {}
      this.transactionkey = (this.$route?.query?.transactionkey || '')
      this.orderby = this.$route?.query?.orderby || 'score'
    }
  },
  watch: {
    $route () {
      this.resetData()
      this.fetchData()
    }
  }
}
</script>
